const autoNgTemplateLoaderTemplate1 = require('./customers-dashboard.template.html');

'use strict';

import { NAVIGATION_ICON } from '../../modules/shared/constants/system/navigationIcons';
import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.customersDashboard', [])
        .config(customersDashboardConfig);

    customersDashboardConfig.$inject = ['$routeProvider'];

    function customersDashboardConfig($routeProvider) {
        $routeProvider
            .when('/customers-dashboard', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'CustomersDashboardController',
                controllerAs: 'vm',
                reloadOnSearch:false,
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                    breadcrumbs: [
                        { label: 'Customers', icon: NAVIGATION_ICON.PEOPLE_OUTLINE }
                    ]
                }
            })
    }
})();